<template>
  <div>
    <Navbar />
    <section class="category-page">
      <Header />
      <get-quote class="mt-2" :quoteCard="quoteCard" />
      <info-content />
      <Questions />
      <customer-comments />
    </section>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/component/navbar/Navbar'
import Header from '@/views/category-pages/health-insurance/Header'
import getQuote from '@/component/categories/GetQuote'
import infoContent from '@/views/category-pages/health-insurance/InfoContent'
import Questions from '@/views/category-pages/health-insurance/Questions'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import Footer from '@/component/footer/Footer'

export default {
  metaInfo: {
    title: 'En Uygun Fiyatlı Sağlık Sigortası Tekliflerini Karşılaştırın',
    meta: [
      {
        name: 'description',
        content:
          'Sağlık sigortası çeşitlerini karşılaştırın, planlar arasından en doğru sağlık sigortası poliçesini seçerek, en uygun fiyatan sağlığınızı güvence altına alın.'
      }
    ]
  },
  name: 'HealthInsurance',
  components: {
    Navbar,
    Header,
    getQuote,
    infoContent,
    Questions,
    customerComments,
    Footer
  },
  data () {
    return {
      faqTitle: 'Sıkça Sorulan Sorular',
      faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
      quoteCard: {
        title: 'Sağlık Sigortası Fiyatlarında AloKasko Avantajı',
        description:
          'İhtiyaçlarınızı ve seçeneklerinizi anlayın. En iyi sağlık sigortası şirketlerinden sigorta fiyatlarını tek bir yerden alın.',
        content: [
          {
            id: 1,
            icon: 'fas fa-file-alt',
            title: 'Güvenebileceğiniz Sağlık Sigortası',
            desc:
              'Kendiniz ve aileniz için sağlık sigortası satın almak istiyorsanız, doğru yere ulaşmanıza yardımcı olabiliriz.'
          },
          {
            id: 2,
            icon: 'fab fa-cc-visa',
            title: 'Sağlık Gerçek Kazançtır',
            desc:
              'Uzman ekibimiz her hangi bir sorunla karşılaşmanız durumunda bir telefon kadar uzağınızda. En iyi planı bulmanıza her zaman yardımcı olur.'
          },
          {
            id: 3,
            icon: 'fas fa-clipboard-check',
            title: 'Sağlığınız İçin İlk Adımı Atın',
            desc:
              'Hayatınızın her aşamasında sağlığınızı desteklemek için hazırlanmış birçok sağlık sigortası planlarımızı keşfedin.'
          },
          {
            id: 4,
            icon: 'fas fa-users-cog',
            title: 'Daha Fazla Tasarruf Edin',
            desc:
              'Hemen hemen her yaşam tarzına ve bütçeye uyan sağlık planları. Sunulan teklifleri değerlendirerek en uygun teklifi farklı ödeme imkânlarıyla alın. '
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss">
@import '@/css/app.scss';
</style>
